var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceWhite81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.4583,
    height: 25,
    fill: "url(#pattern0_35_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_35_127",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_35_127",
    transform: "matrix(0.0232108 0 0 0.0106383 -0.0106383 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_35_127",
    width: 44,
    height: 94,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABeCAMAAABvsAb5AAAAM1BMVEVHcEzn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+fn5+exRWCXAAAAEHRSTlMA+pzzTBrr4ay8YoozdtbKeI7B2wAAAAlwSFlzAAALEgAACxIB0t1+/AAAAMpJREFUWIXt2MsOgyAQheERQUDs5f2ftrFpU+EwY2dB2sX8S8+3MMYQI3XzKS73tsl3aEgzwGcRKJUJFIfDFQyLA94qi0XbYtE2OMPOYw+zgCPMPN5gFfDJHddYfhQ1DjAKeIVRwBcY2/IHJxj35pzeOTrBR0An+AZKwBsoAQMy3Ou32MdXvdMwHstE7DGIOYJLfEmDiwavw3DQYBqFFw2Ow3DW4KTE3791q+J9LnYicRk2zGXYMJdhw3+OHdqJxZSrD+C96k8CET0AdOWT2kFGoscAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceWhite81);
export default __webpack_public_path__ + "static/media/face_white-8 1.d55c44f18e8701ca833fb79f1c834d02.svg";
export { ForwardRef as ReactComponent };